import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileDownload: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFileDownload"><Path fillRule="evenodd" clipRule="evenodd" d="M4.75 2H12V10H20V21.25C20 21.6642 19.6642 22 19.25 22H4.75C4.33579 22 4 21.6642 4 21.25V2.75C4 2.33579 4.33579 2 4.75 2ZM12 20.0607L8.43934 16.5L9.5 15.4393L11.25 17.1893V12H12.75V17.1893L14.5 15.4393L15.5607 16.5L12 20.0607Z" fill="currentColor"/><Path d="M13.5 2.43934L19.5607 8.5H13.5V2.43934Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFileDownload;
